
import { Vue, Component, Prop } from 'vue-property-decorator'

import CustomWrapper from '@/components/CustomWrapper.vue'

const config = {
  name: 'c-poi-card-title',
  components: { CustomWrapper }
}

@Component(config)
export default class CPoiCardTitle extends Vue {

  @Prop({ type: String, default: 'div' }) tag!: string

}
